var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingProClickShortRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 80,
    viewBox: "0 0 113 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    width: 80,
    height: 106,
    rx: 4,
    transform: "rotate(90 113 0)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.666,
    cy: 40.1123,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5113 51.999H71.9113V38.199C71.9113 34.799 71.9113 27.399 61.6613 27.399C57.8613 27.399 54.1113 28.549 51.4613 31.249L54.6113 34.399C56.2113 32.899 58.5113 31.899 61.0113 31.899C64.2113 31.899 66.5113 33.449 66.5113 36.399V37.049H65.0113C59.0113 37.049 49.9113 37.599 49.9113 45.399C49.9113 50.149 54.2113 52.599 58.6613 52.599C61.8613 52.599 64.6613 51.399 66.3613 48.699H66.5113V51.999ZM66.1613 42.599C66.1613 45.949 64.2113 48.099 60.1113 48.099C58.1613 48.099 55.9113 47.149 55.9113 44.949C55.9113 41.499 61.6113 41.249 64.9113 41.249H66.1613V42.599Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7.99902,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 7.99902)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 27.999)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 47.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 47.999)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 67.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 67.999)",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingProClickShortRight);
export default __webpack_public_path__ + "static/media/jobconfig-binding-proClick-short-right.a3cb65f853406fffe0f39b302d253842.svg";
export { ForwardRef as ReactComponent };